import LocalStorage from "./LocalStorage.js";

function checkSidebarScroll() {
	const sidebar = document.querySelector('.sidebar');
	if (!sidebar) {
		return false;
	}

	const scrollTop = sidebar.scrollTop;
	const scrollHeight = sidebar.scrollHeight;
	const clientHeight = sidebar.clientHeight;

	if (scrollHeight <= clientHeight) {
		sidebar.classList.remove('has-top-mask', 'has-bottom-mask');
		return;
	}

	const isAtTop = scrollTop === 0;
	const isAtEnd = Math.floor(scrollTop + clientHeight) >= Math.ceil(scrollHeight);

	if (isAtTop) {
		sidebar.classList.remove('has-top-mask');
		sidebar.classList.add('has-bottom-mask');
	} else if (isAtEnd) {
		sidebar.classList.add('has-top-mask');
		sidebar.classList.remove('has-bottom-mask');
	} else {
		sidebar.classList.add('has-top-mask');
		sidebar.classList.add('has-bottom-mask');
	}
}

export function initSidebar() {
	const sidebar = document.querySelector('.sidebar');
	const sidebarToggle = document.querySelector('#sidebar-toggle');
	const toolList = document.querySelector('.tool-list');

	checkSidebarScroll();

	if (sidebar) {
		sidebar.addEventListener('scroll', checkSidebarScroll);
		const toggles = sidebar.querySelectorAll('label');
		if (toggles) {
			toggles.forEach((toggle) => {
				toggle.addEventListener('click', () => {
					setTimeout(checkSidebarScroll, 350);
				});
			})
		}
	}

	if (toolList) {
		const labels = toolList.querySelectorAll('label');
		labels && labels.forEach((label) => {
			label.addEventListener('click', (event) => {
				const radio = toolList.querySelector('#' + label.getAttribute('for'));
				if (radio.checked) {
					event.preventDefault();
					radio.checked = false;
				}

				if (sidebarToggle?.checked) {
					sidebarToggle.checked = false;
					sidebarToggle.dispatchEvent(new Event('change'));
				}
			});
		})
	}

	if (sidebarToggle) {
		const isSidebarCompact = ! ! parseInt(LocalStorage.getItem('diagnoseo-sidebar-toggle'));
		sidebarToggle.checked = isSidebarCompact;

		sidebarToggle.addEventListener('change', (e) => {
			const isChecked = sidebarToggle.checked ? 1 : 0;
			LocalStorage.setItem('diagnoseo-sidebar-toggle', isChecked);
		});

		const toggleLabel = document.querySelector('.sidebar-toggle-label');
		toggleLabel.addEventListener('click', () => {
			if (!sidebarToggle.checked) {
				sidebarToggle.dispatchEvent(new Event('change'));
			}
		})
	}
}
